<template>
    <div class="third-icons">
        <tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                required: true,
                default: "",
            },
            fabricator: {
                required: true,
            },

            component_id: {
                default() {
                    return 'colour_range';
                }
            },
            securedByDesign: {
                required: false,
                default(){
                    return 1;
                }
            },
            collection: {
                required: false,
                default(){
                    return '';
                }
            },
            typeRange: {
              required: false,
              default(){
                return 0;
              }
            },
            panelCategory: {
              required: false,
              default(){
                return 0;
              }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/colour-range/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/colour-ranges?secured_by_design=' + this.securedByDesign + '&collection=' + this.collection + '&type_range=' + this.typeRange + '&panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.collection + '_' + this.typeRange + '_' + this.panelCategory;
            },
            passed_filter(){
                return this.variable_ready(this.securedByDesign, this.collection,  this.typeRange, this.panelCategory);
            },
            range_count(){
                return this.filtered_option_list.length > 1;
            },
            panel_required() {
              return this.filtered_option_list.length > 1;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
